import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function X(props: Partial<SVGProps<any>> & {dark?: boolean}) {
  const { dark, ...spreadProps} = props;
  return (
<div {...spreadProps} className={twMerge('grid place-items-center',spreadProps.className)}>

<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.2213 0H16.9803L10.9224 6.78966L18 16H12.4459L8.0973 10.4029L3.11896 16H0.35988L6.77774 8.73805L0 0H5.6921L9.62079 5.11295L14.2213 0ZM13.2556 14.4059H14.7851L4.88837 1.53504H3.24492L13.2556 14.4059Z" className={twMerge("fill-[#212021] dark:fill-white", dark && 'fill-white')}/>
</svg>
    </div>
  )
}